import { render, staticRenderFns } from "./LinkStatus.vue?vue&type=template&id=4c12aba4"
import script from "./LinkStatus.vue?vue&type=script&lang=js"
export * from "./LinkStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports